// 1Clin Logo Components

// Horizontal Logo - for headers and large displays
export function Logo1ClinHorizontal({ className = '', width = 500 }) {
  return (
    <svg 
      width={width} 
      height="auto" 
      viewBox="0 0 550 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Icon Group */}
      <circle cx="40" cy="50" r="35" fill="#00ced1" fillOpacity="0.15" stroke="#00ced1" strokeWidth="2" />
      <text x="32" y="65" fontFamily="Inter" fontSize="42" fontWeight="800" fill="white">1</text>
      {/* Medical Cross */}
      <path d="M48 40V48M44 44H52" stroke="#ff8c00" strokeWidth="3" strokeLinecap="round" />
      {/* Growth Arrows */}
      <path d="M60 35L65 30M65 30H61M65 30V34" stroke="#ff8c00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M55 45L60 40M60 40H56M60 40V44" stroke="#ff8c00" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      
      {/* Brand Text */}
      <text x="90" y="62" fontFamily="Inter" fontSize="52" fontWeight="800" fill="white">1Clin</text>
      {/* Full Tagline */}
      <text x="92" y="85" fontFamily="Inter" fontSize="14" fontWeight="400" fill="#94a3b8" letterSpacing="0.5">HEALTHCARE SIMPLIFIED. CARE AMPLIFIED.</text>
    </svg>
  );
}

// App Icon - for small displays, favicons, sidebar
export function Logo1ClinIcon({ size = 48, className = '' }) {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 120 120" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Background Square */}
      <rect width="120" height="120" rx="28" fill="#0f172a" />
      {/* Outer Ring */}
      <circle cx="60" cy="60" r="45" stroke="#00ced1" strokeWidth="4" />
      {/* Main "1" */}
      <text x="48" y="82" fontFamily="Inter" fontSize="64" fontWeight="800" fill="white">1</text>
      {/* Saffron Medical Cross */}
      <path d="M78 40V54M71 47H85" stroke="#ff8c00" strokeWidth="5" strokeLinecap="round" />
      {/* Teal Growth Arrow */}
      <path d="M90 65L100 55M100 55H92M100 55V63" stroke="#00ced1" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// Compact Horizontal Logo - for smaller headers
export function Logo1ClinCompact({ width = 200, className = '' }) {
  return (
    <svg 
      width={width} 
      height="auto" 
      viewBox="0 0 280 60" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Icon Group - scaled down */}
      <circle cx="25" cy="30" r="22" fill="#00ced1" fillOpacity="0.15" stroke="#00ced1" strokeWidth="1.5" />
      <text x="19" y="40" fontFamily="Inter" fontSize="26" fontWeight="800" fill="white">1</text>
      {/* Medical Cross */}
      <path d="M30 24V30M27 27H33" stroke="#ff8c00" strokeWidth="2" strokeLinecap="round" />
      {/* Growth Arrows */}
      <path d="M38 21L42 17M42 17H39M42 17V20" stroke="#ff8c00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      
      {/* Brand Text */}
      <text x="58" y="38" fontFamily="Inter" fontSize="32" fontWeight="800" fill="white">1Clin</text>
      {/* Tagline */}
      <text x="60" y="52" fontFamily="Inter" fontSize="8" fontWeight="400" fill="#94a3b8" letterSpacing="0.3">HEALTHCARE SIMPLIFIED. CARE AMPLIFIED.</text>
    </svg>
  );
}

export default { Logo1ClinHorizontal, Logo1ClinIcon, Logo1ClinCompact };
